import React, { useCallback, useEffect, useState } from "react";

import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
	filterPaper: {
		padding: theme.spacing(2),
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: theme.spacing(2),
	},
	tagPaper: {
		padding: theme.spacing(2),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		height: 120,
		justifyContent: "center",
	},
	tagChip: {
		color: "#FFF",
		fontWeight: 600,
		marginBottom: theme.spacing(1),
	},
	filterField: {
		marginRight: theme.spacing(2),
	},
	queueControl: {
		minWidth: 180,
	},
}));

const TagsDashboard = () => {
	const classes = useStyles();

	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [queueId, setQueueId] = useState("");
	const [queues, setQueues] = useState([]);
	const [tagCounts, setTagCounts] = useState([]);
	const [total, setTotal] = useState(0);

	const fetchTagCounts = useCallback(async (start, end, queue) => {
		try {
			const { data } = await api.get("/tags/dashboard", {
				params: {
					startDate: start || undefined,
					endDate: end || undefined,
					queueId: queue || undefined,
				},
			});
			setTagCounts(data.data);
			setTotal(data.total);
		} catch (err) {
			toastError(err);
		}
	}, []);

	useEffect(() => {
		(async () => {
			try {
				const { data } = await api.get("/queue");
				setQueues(data);
			} catch (err) {
				toastError(err);
			}
		})();
	}, []);

	useEffect(() => {
		fetchTagCounts("", "", "");
	}, [fetchTagCounts]);

	const selectedQueue = queues.find(q => q.id === queueId);

	return (
		<>
			<Grid item xs={12}>
				<Paper className={classes.filterPaper}>
					<Typography component="h3" variant="h6" color="primary">
						Atendimentos por Zona / Tag
					</Typography>
					<FormControl
						variant="outlined"
						size="small"
						className={classes.queueControl}
					>
						<InputLabel id="dashboard-queue-label">Fila</InputLabel>
						<Select
							labelId="dashboard-queue-label"
							label="Fila"
							value={queueId}
							onChange={e => setQueueId(e.target.value)}
						>
							<MenuItem value="">Todas as filas</MenuItem>
							{queues.map(queue => (
								<MenuItem key={queue.id} value={queue.id}>
									{queue.name}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<TextField
						label="Data inicial"
						type="date"
						size="small"
						variant="outlined"
						className={classes.filterField}
						value={startDate}
						onChange={e => setStartDate(e.target.value)}
						InputLabelProps={{ shrink: true }}
					/>
					<TextField
						label="Data final"
						type="date"
						size="small"
						variant="outlined"
						className={classes.filterField}
						value={endDate}
						onChange={e => setEndDate(e.target.value)}
						InputLabelProps={{ shrink: true }}
					/>
					<Button
						variant="contained"
						color="primary"
						onClick={() => fetchTagCounts(startDate, endDate, queueId)}
					>
						Filtrar
					</Button>
					<Button
						variant="outlined"
						color="primary"
						onClick={() => {
							setStartDate("");
							setEndDate("");
							setQueueId("");
							fetchTagCounts("", "", "");
						}}
					>
						Limpar
					</Button>
					<Typography component="span" variant="body1">
						{selectedQueue ? `Fila: ${selectedQueue.name} | ` : "Todas as filas | "}
						Total no período: <strong>{total}</strong>
					</Typography>
				</Paper>
			</Grid>
			{tagCounts.map(tag => (
				<Grid item xs={6} sm={4} md={3} lg={2} key={tag.id}>
					<Paper className={classes.tagPaper}>
						<Chip
							className={classes.tagChip}
							style={{ backgroundColor: tag.color || "#7C7C7C" }}
							label={tag.name}
						/>
						<Typography component="h1" variant="h4">
							{tag.ticketCount}
						</Typography>
					</Paper>
				</Grid>
			))}
		</>
	);
};

export default TagsDashboard;
